import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPlusCircleIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 12,
	height: 12,
	viewBox: "0 0 12 12",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		opacity: .5,
		d: "M6 11C8.76142 11 11 8.76142 11 6C11 3.23858 8.76142 1 6 1C3.23858 1 1 3.23858 1 6C1 8.76142 3.23858 11 6 11Z",
		stroke: "#FFFFFF",
		strokeWidth: 1.5
	}), /* @__PURE__ */ _jsx("path", {
		d: "M7.5 6H6M6 6H4.5M6 6V4.5M6 6V7.5",
		stroke: "#FFFFFF",
		strokeWidth: 1.5,
		strokeLinecap: "round"
	})]
});
export default SvgPlusCircleIcon;
